import React from "react";

function Footer() {
  return (
    <footer className="app-footer">
      <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center">
        <span>
          &copy;{" "}
          <a
            href="https://cvalenciait.com"
            target="_blank"
            rel="noreferrer"
          >
            cvalenciait.com
          </a>
        </span>
        <span className="mt-1 mt-sm-0">
          Hand-crafted &amp; made with{" "}
          <i className="mdi mdi-heart-outline" aria-hidden="true" />
        </span>
      </div>
    </footer>
  );
}

export { Footer };
